import { authFetch } from 'src/auth/utils';
import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { envVariables } from 'src/common/utils/envVariables';
import { UsageDto } from 'src/common/utils/mapUsageDTOtoAreaChartData';
import { DetailsTypeValue } from '../UsageChartsSection';

export type MonthlyUsageDto = {
  unit: string;
  data: { label: string; value: { mt: string; mo: string; total: string } }[];
};

type GetMonthlyUsageDataProps = {
  id: string;
  usageType: UsageTypeValue;
  detailsType: DetailsTypeValue;
};

export const getMonthlyUsage = async (
  { id, usageType, detailsType }: GetMonthlyUsageDataProps,
  signal?: AbortSignal,
) => {
  const response = await authFetch(
    `${envVariables.VITE_ANALYTICS_MODULE_URL}/usage/${detailsType}/${id}/monthly/${usageType}`,
    {
      signal,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const responseJSON: MonthlyUsageDto = await response.json();

  return responseJSON;
};

type GetDailyUsageDataProps = {
  id: string;
  usageType: UsageTypeValue;
  chartType: ChartTypeValue;
  detailsType: DetailsTypeValue;
};

export const getDailyUsage = async (
  { id, usageType, chartType, detailsType }: GetDailyUsageDataProps,
  signal?: AbortSignal,
) => {
  const response = await authFetch(
    `${envVariables.VITE_ANALYTICS_MODULE_URL}/usage/${detailsType}/${id}/daily/${chartType}/${usageType}`,
    {
      signal,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const responseJSON: UsageDto = await response.json();

  return responseJSON.chartData;
};
